import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-button-type"]
const _hoisted_2 = { class: "tool-header-button-item__img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tool-header-button-item__txt" }

import {
  useSlots,
  withDefaults,
  defineOptions,
  ref,
} from "vue";
import { mapModifires, type typeModifires } from "@/components/utils/modifires";

import icon01 from "@/../public/icon/index/icon-tool-btn-01.svg";
import icon02 from "@/../public/icon/index/icon-tool-btn-02.svg";
import icon03 from "@/../public/icon/index/icon-tool-btn-03.svg";
import icon04 from "@/../public/icon/index/icon-tool-btn-04.svg";
import icon05 from "@/../public/icon/index/icon-tool-btn-05.svg";
import icon06 from "@/../public/icon/index/icon-tool-btn-06.svg";
import icon07 from "@/../public/icon/index/icon-tool-btn-07.svg";
import icon08 from "@/../public/icon/index/icon-tool-btn-08.svg";
import icon10 from "@/../public/icon/index/icon-tool-btn-10.svg";
import icon11 from "@/../public/icon/index/icon-tool-btn-11.png";
import icon13 from "@/../public/icon/index/icon-tool-btn-13.png";

interface Props {
  modifires?: typeModifires;
  type?: "button" | "submit" | "reset";
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'tool-header-button-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





const slots = useSlots();

const innerTextAry: string[] = [];
slots.default!().forEach((item) => {
  if (item.children && typeof item.children === "string") {
    innerTextAry.push(item.children);
  }
});
const innerText: string = innerTextAry.join("");
const images: { [key: string]: string } = {
  計測: icon01,
  画面キャプチャ: icon02,
  データダウンロード: icon03,
  ベクタ読み込み: icon04,
  ベクタクリア: icon05,
  設定出力: icon06,
  設定読み込み: icon07,
  マニュアル: icon08,
  簡易検索モード: icon10,
  全画面表示: icon11,
  凡例表示: icon13,
};


const handleClick = (e: Event) => {
  emit("click", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('tool-header-button-item', _ctx.modifires)),
    "data-button-type": _unref(innerText)
  }, [
    _createElementVNode("button", {
      onClick: handleClick,
      class: "tool-header-button-item__btn",
      type: "button"
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          src: images[_unref(innerText)],
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 10, _hoisted_1))
}
}

})